
const Radio = ({ defaultChecked, checked, onChange, label }: any) => {
    return (
        <div style={{ cursor: "pointer", display: "inline-flex" }}>
            <input
                type="radio"
                checked={checked}
                onChange={onChange}
                defaultChecked={defaultChecked}
                style={{
                    display: "none",
                }}
                tabIndex={0}
            />

            <span
                style={{
                    width: "20px",
                    height: "20px",
                    borderRadius: "50%",
                    border: checked ? "7px solid #00CBAF" : "none",
                    backgroundColor: checked ? "#3A4763" : "#828FAB",
                    transition: "background-color 0.3s",
                    display: "inline-block",
                }}
            />
        </div>
    );
};

export default Radio;
